import React, { useState } from "react";
import "./style.css";

const CustomCursor = () => {
  // const { type } = useContext(CustomCursorContext);
  const secondaryCursor = React.useRef(null);
  const [enabled, setEnabled] = useState(false);
  const positionRef = React.useRef({
    mouseX: 0,
    mouseY: 0,
    destinationX: 0,
    destinationY: 0,
    distanceX: 0,
    distanceY: 0,
    key: -1,
    running: false,
  });

  // Only run the cursor on devices with a real pointer (not touch).
  React.useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(hover: hover) and (pointer: fine)");
    const update = () => setEnabled(mq.matches);
    update();
    mq.addEventListener?.("change", update);
    return () => mq.removeEventListener?.("change", update);
  }, []);

  React.useEffect(() => {
    if (!enabled) return undefined;
    const state = positionRef.current;

    const followMouse = () => {
      const {
        mouseX,
        mouseY,
        destinationX,
        destinationY,
        distanceX,
        distanceY,
      } = state;
      if (!destinationX || !destinationY) {
        state.destinationX = mouseX;
        state.destinationY = mouseY;
      } else {
        state.distanceX = (mouseX - destinationX) * 0.1;
        state.distanceY = (mouseY - destinationY) * 0.1;
        if (Math.abs(state.distanceX) + Math.abs(state.distanceY) < 0.1) {
          state.destinationX = mouseX;
          state.destinationY = mouseY;
        } else {
          state.destinationX += distanceX;
          state.destinationY += distanceY;
        }
      }
      if (secondaryCursor && secondaryCursor.current)
        secondaryCursor.current.style.transform = `translate3d(${destinationX}px, ${destinationY}px, 0)`;

      // Idle: the cursor has caught up with the pointer - stop the loop
      // entirely instead of burning a frame every 16ms. The next mousemove
      // restarts it.
      const settled =
        Math.abs(mouseX - state.destinationX) +
          Math.abs(mouseY - state.destinationY) <
        0.1;
      if (settled) {
        state.running = false;
        return;
      }
      state.key = requestAnimationFrame(followMouse);
    };

    const onMove = (event) => {
      const { clientX, clientY } = event;
      if (!secondaryCursor.current) return;
      positionRef.current.mouseX =
        clientX - secondaryCursor.current.clientWidth / 2;
      positionRef.current.mouseY =
        clientY - secondaryCursor.current.clientHeight / 2;
      if (!state.running) {
        state.running = true;
        state.key = requestAnimationFrame(followMouse);
      }
    };

    document.addEventListener("mousemove", onMove);

    return () => {
      document.removeEventListener("mousemove", onMove);
      state.running = false;
      cancelAnimationFrame(state.key);
    };
  }, [enabled]);

  if (!enabled) return null;

  return (
    <div className={`cursor-wrapper default`}>
      <div className="secondary-cursor" ref={secondaryCursor}></div>
    </div>
  );
};

export default CustomCursor;
